import type React from "react";
import type { ReactNode } from "react";
import { YStack } from "tamagui";
import { Body } from "./Body";
import type { IconProp } from "./icons";
import { Title } from "./Title";

type CenterContentProps = {
  title?: JSX.Element | string;
  subTitle?: JSX.Element | string;
  icon?: IconProp;
  muted?: boolean;
  children?: ReactNode;
};

export const CenterContent: React.FC<CenterContentProps> = ({
  title,
  subTitle,
  icon,
  muted,
  children,
}) => {
  const Icon = icon;

  return (
    <YStack
      width={"100%"}
      flexWrap="wrap"
      gap="$medium"
      justifyContent="center"
      flex={1}
      alignItems="center"
      marginVertical="$large"
    >
      {!!Icon && <Icon color={"$color"} size={"$size.medium"} />}
      {!!title && <Title>{title}</Title>}
      {!!subTitle && (
        <Body textAlign="center" flex={1} muted={muted} maxWidth={"80%"}>
          {subTitle}
        </Body>
      )}
      {children}
    </YStack>
  );
};
